import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.toasterBar || initialState;

export const selectToasterBar = createSelector([selectSlice], state => state);
